import React, {useEffect, useState} from 'react'
import './SsoPage.scss'
import Loading from './Loading/Loading';
import Error from './Error/Error';
import Success from './Success/Success';
import Consent from './Consent/Consent';
import { axiosApi, expireInDay } from "api/helper";
import * as authActions from "store/actions/authActions";
import * as accountActions from "store/actions/accountActions";
import { connect } from 'react-redux';
import LogoCustomTheme from 'components/Theme/Logo/LogoCustomTheme';

const SsoPage = ({history, setTokens, setAccountDatas}) => {
    const [status, setStatus] = useState('loading');
    const [userId, setUserId] = useState('');
    const [retailer, setRetailer] = useState('');

    const onValidateConsent = (data) => {
        const payload = {
            isNewUser: userId,
            retailer: retailer,
            newsletterAccepted: data.newsletter,
            touAccepted: true
        }

        createOrGetUser(payload)
        .then((data) => {
            setStatus('success');
            setTimeout(() => {
                login(data)
            }, 3000);
        }).catch(() => {
            setStatus('error');
        });
    }

    const tryToLoginUser = (userId, retailer) => {
        const payload = {
            isUser: userId,
            retailer: retailer,
        }

        createOrGetUser(payload)
            .then((data) => {
                setTimeout(() => {
                    login(data)
                }, 3000);
            }).catch(() => {
            setStatus('error');
        });
    }

    const login = (data) => {
        axiosApi("account", {}, "get", {
            Authorization: `Bearer ${data.access_token}`
        }).then(
            dataUser => {
                // Temps d'expiration
                const expire_date = Date.now() + expireInDay * 1000 * 60 * 60 * 24;

                // stockage tokens dans redux
                setTokens({ ...data, expire_date: expire_date });

                // stockage user dans redux
                setAccountDatas(dataUser);

                // go homepage
                history.replace("/");
            },
        );
    }

    const renderStatus = () => {
        switch (status) {
            case 'consent':
                return <Consent onValidate={onValidateConsent} />
            case 'success':
                return <Success />
            case 'error':
                return <Error />
            case 'loading':
            default:
                return <Loading />;
        }
    }

    useEffect(() => {
        const params = (new URL(document.location)).searchParams;
        const isNewUser = params.get('isNewUser');
        const isUser = params.get('isUser');
        const retailer = params.get('retailer');
        const error = params.get('error');

        if(error) {
            setStatus('error');
        } else if(isNewUser) {
            setUserId(isNewUser)
            setStatus('consent');
            setRetailer(retailer)
        } else if(isUser) {
            tryToLoginUser(isUser, retailer)
        } else {
            history.push('/connect')
        }
    }, [history])

    return (
        <div className='sso-wrapper'>
            <LogoCustomTheme className="we-are-ll" />
            <div className='sso-content'>
                {renderStatus()}
            </div>
        </div>
    )
}

const createOrGetUser = (payload) => {
    return axiosApi ("sso/retailer/auth", payload, "post", {}, {ispublic: true});
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => {
    return {
        setTokens: (data) => dispatch(authActions.setTokens(data)),
        setAccountDatas: (data) => dispatch(accountActions.setAccountDatas(data))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(SsoPage)
